import React from 'react'
import { Navbar } from '../global/Navbar/navbar'



const Header = ({setViewDiagnosis}) => {
 return (
  <header className="header-diseases">
   <div className="container">
    <Navbar active="blogs" setViewDiagnosis={setViewDiagnosis} />
    <div className="flex-col ">
      <h2 className="heading__primary mt--huge mb--large">
      Blogs
      </h2>
      <p className="paragraph width--40 pos--relative">
       Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim
      </p>
    </div>
   </div>
  </header>
 )
}

export default Header
